import { autoElement } from '../../../webmodule-common/components/src/common/lit-decorator-extended';
import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { CynclySupportView } from './cyncly-support-view';
import { DataEntryPageControlView } from '../../../webmodule-common/other/ui/data-entry-screen-base';

import {
  MenuIconOption,
  PageButtonLocation,
  PageControl,
  PageControlOptions,
  PageManager
} from '../../../webmodule-common/other/ui/page-control';

@autoElement()
export class TenantView extends DataEntryPageControlView {
  private cynclyStaffView?: CynclySupportView;

  constructor() {
    super();
  }

  public async afterConstruction(): Promise<void> {
    this.cynclyStaffView = await constructAsync(new CynclySupportView());

    await super.afterConstruction();
    this.pageControl.pageButtonLocation = PageButtonLocation.right;
    this.pageControl.hideSingleTab = true;
  }

  public getTitle() {
    return 'Tenant Network';
  }

  public async setActiveTabByHash() {
    await this.pageControl.applyWindowHash();
  }

  createPageControl(): PageControl {
    // build static pages for each of the configured table settings
    const getInitialPageManagers = (): PageManager[] => {
      const pages: PageManager[] = this.cynclyStaffView ? [this.cynclyStaffView.createPageManager()] : [];

      return pages;
    };
    const menu: MenuIconOption[] = [];
    const options: PageControlOptions = {
      defaultTabIndex: 0,
      menuIcons: menu,
      pageInitializer: () => getInitialPageManagers()
    };
    return new PageControl(options);
  }

  async prepareForSave(): Promise<void> {
    //DOES NOTHING HANDLED BY CHILDREN
  }

  public internalDataChanged(): boolean {
    return false;
  }
}
